import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import * as moment from "moment";
import * as _ from "underscore";
import { Subject, Subscription, fromEvent } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { ApiService } from "app/modules/shared/services/api.service";
import { AnalyticService } from "app/modules/shared/services/analytic.service";
import { Router } from "@angular/router";
import * as FileSaver from "file-saver";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: 'app-stars-lessons-usage-count-analtics',
  templateUrl: './stars-lessons-usage-count-analtics.component.html',
  styleUrls: ['./stars-lessons-usage-count-analtics.component.scss']
})
export class StarsLessonsUsageCountAnalticsComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild("searchInput", { static: false }) searchInput: ElementRef;
  @Input() selectedApp: any;
  @Input() dateData$: Subject<any>;
  @Input() practieSetName: string;
  @Input() psData: any;
  isShowDate: boolean = false;
  isMessage: boolean = false;
  isPage: boolean = true;
  listDateRange: any = "daySelected";
  listDates: any = "";
  totalDifficultPSets: any;
  leastDifficultPSetsList = [];
  date: any;
  dateInfo: any;
  subsink: Subscription;

  constructor(public analyticService: AnalyticService, public router: Router, public api: ApiService) {}

  ngOnInit() {    
    this.displayedColumns = ["userName", "sessionCount", "duration"];
    
   /* this.subsink = this.dateData$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((v) => {
      if (v) {
        this.dateInfo = v;
        this.triggerDateSelection(v);
      }
    });*/

    this.subsink = this.api.dateRange$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
          if (next) {
            this.dateInfo = localStorage.getItem("dateRange");
            if (this.dateInfo) {
              next = JSON.parse(this.dateInfo);
            }
            this.triggerDateSelection(next);
          }
    });
  }

  triggerDateSelection(data) {
    switch (data.type) {
      case "Day": {
        this.daySelected();
        break;
      }
      case "Month": {
        this.monthSelected();
        break;
      }
      case "Year": {
        this.yearSelected();
        break;
      }
      case "range": {
        this.rangeSelected(data);
        break;
      }
    }
  }

  daySelected() {
    // this.toShowExpandText = false;
    this.practiceSetSelected("daySelected");
    // this.sessionPlayedDaySelected('daySelected');
    // this.renderChartForSessionPlayedByDay(this.selectedDateForDay);

    // Set the calendar range to the last 31 days
    const currentDate = new Date();
    const startDate = new Date();
    startDate.setDate(currentDate.getDate() - 30);

    this.date = {
      startDate: startDate,
      endDate: currentDate,
    };
  }

  monthSelected() {
    // this.toShowExpandText = false;
    this.practiceSetSelected("monthSelected");
    // this.sessionPlayedMonthSelected('monthSelected');
    // this.renderChartForSessionPlayedByMonth(this.selectedMonth);

    // Set the calendar range to show the last 2 years
    const today = new Date();
    const twoYearsAgo = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());
    this.date = {
      startDate: twoYearsAgo,
      endDate: today,
    };
  }

  yearSelected() {
    this.practiceSetSelected("yearSelected");
    // this.sessionPlayedYearSelected('yearSelected');
    const today = new Date();
    const fourYearsAgo = new Date(today.getFullYear() - 5, today.getMonth(), today.getDate());
    this.date = {
      startDate: fourYearsAgo,
      endDate: today,
    };
  }

  rangeSelected(result) {
    // this.sessionPlayedYearSelected('rangeSelected');
    let startDate = moment(result.startDate).format("YYYY-MM-DD");
    let endDate = moment(result.endDate).format("YYYY-MM-DD");
    this.difficultPSetsOnDateRange(startDate, endDate);
    this.date = {
      startDate: startDate,
      endDate: endDate,
    };
  }

  practiceSetSelected(data) {
    this.isShowDate = false;
    this.isMessage = false;
    let selectData: string = "";
    if (data == "daySelected") {
      this.listDateRange = "daySelected";
      selectData = "day";
      this.listDates = moment(new Date()).subtract(1, "d").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    } else if (data == "monthSelected") {
      this.listDateRange = "monthSelected";
      selectData = "month";
      this.listDates = moment(new Date()).subtract(1, "M").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    } else if (data == "yearSelected") {
      this.listDateRange = "yearSelected";
      selectData = "year";
      this.listDates = moment(new Date()).subtract(1, "y").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    }
    this.totalDifficultPSets = [];
    this.analyticService.starsLessonAnalyticsUsageCount(selectData, this.selectedApp.id, null, this.selectedApp.dataId).subscribe(
      (res) => {
        let dataList: any = res;
        this.isPage = false;
        if (!_.isUndefined(dataList)) {
          if (dataList.length == 0) {
            this.isMessage = true;
          }
            let lDPSets = dataList;
            this.leastDifficultPSetsList = lDPSets.map((v) => ({ ...v, pSetSuffix: this.api.getNameSuffix(v.name) }));
            this.totalDifficultPSets = this.leastDifficultPSetsList;
            this.dataSource = new MatTableDataSource(this.totalDifficultPSets);
            this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
              if (typeof data[sortHeaderId] === "string") return data[sortHeaderId].toLocaleLowerCase();
              return data[sortHeaderId];
            };
            this.paginator.firstPage();
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        } else this.totalDifficultPSets = [];
      },
      (err) => {
        this.api.getError(err);
        this.isPage = true;
        this.isMessage = true;
      }
    );
  }

  applyFilter() {
    const searchPS = fromEvent<any>(this.searchInput.nativeElement, "keyup").pipe(
      map((event) => event.target.value),
      debounceTime(500),
      distinctUntilChanged()
    );
    searchPS.subscribe((res) => {
      this.dataSource.filter = res.trim().toLowerCase();
    });
  }

  difficultPSetsOnDateRange(startDate, endDate) {
    this.leastDifficultPSetsList = [];
    this.totalDifficultPSets = [];
    this.isPage = true;
    this.isMessage = false;
    this.analyticService.starsLessonAnalyticsUsageCountDateRange(startDate, endDate, this.selectedApp.id, null, this.selectedApp.dataId).subscribe(
      (res) => {
        let dataList: any  = res;
        this.isPage = false;
        this.listDateRange = moment(startDate).format("MM/DD/YYYY") + " - " + moment(endDate).format("MM/DD/YYYY");
        this.isShowDate = true;
        this.listDates = moment(startDate).format("MM/DD/YYYY") + " - " + moment(endDate).format("MM/DD/YYYY");

        if (!_.isUndefined(dataList)) {
          if (dataList.length == 0) {
            this.isMessage = true;
          }
          let lDPSets = dataList;
          this.leastDifficultPSetsList = lDPSets.map((v) => ({ ...v, pSetSuffix: this.api.getNameSuffix(v.name) }));
          this.totalDifficultPSets = this.leastDifficultPSetsList;
          this.dataSource = new MatTableDataSource(this.totalDifficultPSets);
          this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
            if (typeof data[sortHeaderId] === "string") return data[sortHeaderId].toLocaleLowerCase();
            return data[sortHeaderId];
          };
          this.paginator.firstPage();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else this.totalDifficultPSets = [];
      },
      (err) => {
        this.api.getError(err);
        this.isPage = true;
        this.isMessage = true;
      }
    );
  }

  isFiniteNumber(value: number): boolean {
    return isFinite(value);
  }

  openPracSetAnalyticsView(data) {
    this.api.addRoute(0, this.selectedApp.title, this.selectedApp.id);
    // this.api.addRoute(0);
    if (this.selectedApp.title == "ERAM Keyboard") {
      localStorage.setItem("selectedApp", JSON.stringify({ ...this.selectedApp, dataId: data.lessonId }));
      this.router.navigate(["main/practiceSet/analytics", data.lessonId, data.name]);
    } else if (this.selectedApp.title == "Advanced Vectoring") {
      let dateInfo: any = {
        count: this.dateInfo.count,
        from: this.dateInfo.from,
        label: this.dateInfo.label,
        to: this.dateInfo.to,
        type: this.dateInfo.type,
        endDate: this.dateInfo.endDate,
        startDate: this.dateInfo.startDate,
      };
      let appData = { ...this.selectedApp, dataId: data.missionId, missionType: data.missionType, missionName: data.title, dateInfo: dateInfo };
      localStorage.setItem("selectedApp", JSON.stringify(appData));
      this.router.navigate(["main/practiceSet/analytics", data.missionId, data.title]).then(() => {
        this.api.addRoute(0, data.title, data.missionId);
      });
    } else if (this.selectedApp.title == "Basic Vectoring") {
      //SG-7046 start
      let dateInfo: any = {
        count: this.dateInfo.count,
        from: this.dateInfo.from,
        label: this.dateInfo.label,
        to: this.dateInfo.to,
        type: this.dateInfo.type,
        endDate: this.dateInfo.endDate,
        startDate: this.dateInfo.startDate,
      };
      let appData = { ...this.selectedApp, dataId: data.lessonId, lessonType: data.lessonType, lessonName: data.title, dateInfo: dateInfo };
      localStorage.setItem("selectedApp", JSON.stringify(appData));
      this.router.navigate(["main/practiceSet/analytics", data.lessonId, data.title]).then(() => {
        this.api.addRoute(0, data.title, data.lessonId);
      }); // SG-7046 end
    } else if (this.selectedApp.title == "STARS Keyboard") {
      localStorage.setItem("selectedApp", JSON.stringify({ ...this.selectedApp, dataId: data.lessonId }));
      this.router.navigate(["main/practiceSet/analytics/view", "detail", data.lessonId, data.lessonName]);
    } else {
      localStorage.setItem("selectedApp", JSON.stringify({ ...this.selectedApp, dataId: data.praticeSetId }));
      this.router.navigate(["main/practiceSet/analytics/view", "detail", data.praticeSetId, data.name]);
    }
  }

  openFolderAnalyticsView(data) {
    this.api.addRoute(0, this.selectedApp.title, this.selectedApp.id);
    if (data.folder !== null) {
      this.router.navigate(["main/folderAnalytics/app", data.folderId, this.selectedApp.title, data.folder]);
    }
  }

  async exportCsvData() {
    let dateType;
    if (this.listDateRange == "daySelected") dateType = "day";
    else if (this.listDateRange == "monthSelected") dateType = "month";
    else if (this.listDateRange == "yearSelected") dateType = "year";
    else if (this.listDateRange == "rangeSelected") {
      dateType = "range";
    }
    let requestParam = "";
    try {
      this.analyticService.starsLessonAnalyticsUsageCountExport(dateType, this.date.startDate, this.date.endDate, this.selectedApp.id, requestParam, null, this.selectedApp.dataId).subscribe(
        (data) => {
          let dataObject: any = data;
          if (data.type === "application/zip") {
            var blob = new Blob([data], { type: data.type });
            FileSaver.saveAs(blob, "starsLessonAnalyticsUsageCount".toUpperCase() + ".zip");
          } else {
            var blob = new Blob([data], { type: "application/csv" });
            FileSaver.saveAs(blob, "starsLessonAnalyticsUsageCount".toUpperCase() + ".csv");
          }
        },
        (err) => {
          this.api.getError(err);
        }
      );
    } catch (error) {}
  }
  // ***********  SG-7203 start*************************

  ngOnDestroy(): void {
    if (this.subsink) {
      this.subsink.unsubscribe();
    }
  }

  openUserDialog(event) {     
    this.api.showDateSelector = false;
    this.router.navigate(["main/practiceSet/analytics/user", "member", this.psData.id, this.psData.name, event.userName]);    
  }    
}
